import React, { useRef, useMemo } from 'react';
import './index.scss';
import AIContent from '../AIContent';
import type { IAIContentRef } from '../AIContent/_type';
import DownloadLink from '../DownloadLink';
import { formatChartTaleDta, formatData, shouldRenderAsDownload } from './_utils';
import { useDSChartConfig } from './useDSChartConfig';

type TChartAdapterProps = {
  apiData: any[];
};

const ChartAdapter: React.FC<TChartAdapterProps> = ({ apiData }) => {
  let contentData = null;
  try {
    console.log('inputData', apiData);
    contentData = formatChartTaleDta(formatData(apiData));
  } catch (error) {
    console.log('formatChartTaleDta error', error);
  }
  
  console.log('outputData', contentData);
  
  const systemMap: Record<string, string> = {
    dashboard: 'Dashboard',
    opinion: 'Opinions',
    intelligence: 'Intelligence',
  };

  const system = apiData[0]?.system
    ? systemMap[apiData[0].system.toLowerCase()] || ''
    : '';

  const chartDataId = apiData?.[0]?.data_id || '';
  const hideSource = apiData?.[0]?.hideSource;
  // 创建 ref 用于控制 AIContent 的状态
  const aiContentRef = useRef<IAIContentRef>(null);

  // 使用 DS hooks 处理所有 DS 相关逻辑
  const {
    onFilterChange,
    onMetricChange,
    defaultShowFilters,
    defaultShowMetrics
  } = useDSChartConfig({ chartDataId, aiContentRef, hideSource });

  // 判断是否应该显示下载链接
  const renderDecision = useMemo(() => {
    if (!contentData) {
      return { shouldShowDownload: false, reason: 'normal' as const };
    }
    return shouldRenderAsDownload(apiData, contentData);
  }, [apiData, contentData]);

  // 如果应该显示下载链接
  if (renderDecision.shouldShowDownload && contentData) {
    return (
      <DownloadLink
        formattedData={{
          xAxis: contentData.xAxis,
          legends: contentData.legends,
          filter_info: contentData.filter_info,
          dimension_info: contentData.dimension_info,
          metrics_info: contentData.metrics_info,
          data: contentData.data,
          title: contentData.title,
        }}
        rawData={contentData.data}
        downloadTitle={contentData.title}
        // 筛选器设置为空，下载全量数据
        filterVal={{}}
        enableNotification={false} 
      />
    );
  }

  // 默认显示 AIContent
  return (
    <>
      {contentData && (
        <AIContent
          ref={aiContentRef}
          {...contentData}
          system={system}
          isCopilot={apiData?.[0]?.from === 'copilot'}
          chartHeight={apiData?.[0]?.chartHeight}
          hideSource={hideSource}
          chartDataId={chartDataId}
          onFilterChange={onFilterChange}
          onMetricChange={onMetricChange}
          defaultShowMetrics={defaultShowMetrics}
          defaultShowFilters={defaultShowFilters}
        />
      )}
    </>
  );
};

export default React.memo(ChartAdapter, (prevProps, nextProps) => {
  return prevProps?.apiData?.[0]?.data_id === nextProps?.apiData?.[0]?.data_id;
});
